import React from "react";
import NotFoundComponent from "../../views/web/notFound";

export default function NotFoundPage() {
  return <NotFoundComponent />;
}
